import { setIsCartOpen } from 'src/state/cart/cart-slice';
import { AppDispatch, RootState } from 'src/state/types';

export const toggleCartActionCreator = (isOpen?: boolean) => (dispatch: AppDispatch, getState: () => RootState) => {
  const {
    cart: { isCartOpen },
  } = getState();

  dispatch(setIsCartOpen(isOpen ?? !isCartOpen));
};
